/**
 * 校验规则
 */
export default {
  // 验证手机规则
  checkMobile: (rule, value, callback) => {
    if (!!value && !(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value) || /^[0]\d{3,4}-?\d{7,8}$/.test(value))) {
      callback(new Error('联系电话格式不正确'))
    } else {
      callback()
    }
  },
  // 验证邮箱
  checkEmail: (rule, value, callback) => {
    if (value) {
      // eslint-disable-next-line no-control-regex
      const flag = /^((([a-z]|\d|[!#\$%&\'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&\'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
        .test(value)
      if (!flag) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  },
  // 验证身份证
  checkId: (rule, value, callback) => {
    if (!!value && !/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
      callback(new Error('证件输入错误，请检查证件号码'))
    } else {
      callback()
    }
  },
  // 验证用户名首位必须是字母
  checkUser: (rule, value, callback) => {
    if (!!value && !/^[a-zA-Z]\w{4,19}$/.test(value)) {
      callback(new Error('请输入5-20个字符，第一位必须字母，支持字母、数字组合'))
    } else {
      callback()
    }
  },
  // 验证密码由数字 字母 特殊字符 两种结合
  checkPwd: (rule, value, callback) => {
    if (!!value && !/(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/.test(value)) {
      callback(new Error('请输入6-16个字符，由数字、字母、特殊字符两种结合'))
    } else {
      callback()
    }
  },
  // 验证正整数
  validInteger: (rule, value, callback) => {
    if (!!value && !/^[1-9]\d*$/.test(value)) {
      callback(new Error('请输入正整数'))
    } else {
      callback()
    }
  },
  // 验证正数
  validPositiveNumber: (rule, value, callback) => {
    if (!!value && value < 0) {
      callback(new Error('不能为负数'))
    } else {
      callback()
    }
  },
  // 验证数值
  validNumber: (rule, value, callback) => {
    if (!!value && !/^-?\d{1,16}(?:\.\d{0,12})?$/.test(value)) {
      callback(new Error('只能是数字'))
    } else {
      callback()
    }
  },
  // 验证最多只能输入30个汉字或60个字符
  validHanzi: (rule, value, callback) => {
    // eslint-disable-next-line no-control-regex
    const reg = /[^\x00-\xff]/g
    const length = (value + '').replace(reg, '01').length
    if (length > 60) {
      callback(new Error('长度不能超过30个汉字或者60个字符'))
    } else {
      callback()
    }
  },
  // 验证最多只能输入100个汉字或200个字符
  validHanzis: (rule, value, callback) => {
    // eslint-disable-next-line no-control-regex
    const reg = /[^\x00-\xff]/g
    const length = (value + '').replace(reg, '01').length
    if (length > 200) {
      callback(new Error('长度不能超过100个汉字或者200个字符'))
    } else {
      callback()
    }
  },
  // 验证最多只能输入60个汉字
  validChinese: (rule, value, callback) => {
    // eslint-disable-next-line no-control-regex
    const reg = /[^\x00-\xff]/g
    const length = (value + '').replace(reg, '01').length
    if (length > 120) {
      callback(new Error('长度不能超过60个汉字'))
    } else {
      callback()
    }
  },
  // 验证最多只能输入10个字符
  validzifu: (rule, value, callback) => {
    // eslint-disable-next-line no-control-regex
    const reg = /[^\x00-\xff]/g
    const length = (value + '').replace(reg, '01').length
    if (length > 10) {
      callback(new Error('长度不能超过10位'))
    } else {
      callback()
    }
  },
  /// 验证全部空格
  checkBlank: (rule, value, callback) => {
    if (!!value && !value.trim()) {
      callback(new Error('不能全部为空格'))
    } else {
      callback()
    }
  },
  // 验证ip地址
  checkIP: (rule, value, callback) => {
    if (!!value && !/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(value)) {
      callback(new Error('请输入正确的ip地址'))
    } else {
      callback()
    }
  }
}
